import { SESSION_STORAGE_KEYS, TRACKING } from 'common/constants/constants';
import { SPACES } from 'common/constants/sizes';
import { getColor } from 'common/constants/_colors';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import Background from 'components/Background';
import { Flex, Padding } from 'components/base/layout-components';
import svgLogo from 'images/logos/linearb-logo.svg';
import {
  createInvitationSentSuccessfullyModalOptions,
  createInvitationRequestExpiredModalOptions
} from 'modals/modal-options-factory';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { parseJwt } from 'common/utils/utils';
import axios from 'axios';
import { API } from 'common/constants/api-urls';
import * as TrackingService from 'common/services/tracking.service';
import { getEmailInvitationParams } from 'common/services/invitations.service';
import { LBButton } from '@linearb/buzz';

const sessionStorageAccessor = BrowserStorageAccessor().session;

const LogoWrapper = styled(Flex)`
  height: 100%;
  justify-content: center;
  border-right: 1px solid ${getColor('botticelli')};
  padding-right: ${SPACES.medium};
`;

const Logo = styled.img`
  height: 100%;
  width: 14rem;
`;

const TopBar = styled(Flex)`
  height: 8rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  padding-left: ${SPACES.medium};
  background-color: white;
  z-index: 1400;
`;

const SendInvitation = ({ toggleModal }) => {
  useEffect(() => {
    const createInvitationToken = `Bearer ${sessionStorageAccessor.get(
      SESSION_STORAGE_KEYS.CREATE_INVITATION_TOKEN
    )}`;

    axios
      .create({
        headers: {
          authorization: createInvitationToken
        },
        ...getEmailInvitationParams(false)
      })
      .post(API.PUBLIC_INVITATIONS_PATH)
      .then(() => {
        const jwtPayload = parseJwt(createInvitationToken);
        TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
          page: TRACKING.PAGES.SEND_INVITATION,
          click_type: TRACKING.CLICK.INVITATION_SENT,
          context: {
            orgId: jwtPayload.organization_id
          }
        });
        toggleModal(
          createInvitationSentSuccessfullyModalOptions({
            name: jwtPayload.invitee_name
          })
        );
      })
      .catch(e => {
        toggleModal(
          createInvitationRequestExpiredModalOptions({ toggleModal })
        );
      });
  }, []);

  return (
    <>
      <TopBar>
        <LogoWrapper>
          <Logo src={svgLogo} />
        </LogoWrapper>
        <Padding r={'large'}>
          <LBButton
            variant='outline'
            onClick={() => {
              window.location = '/dashboard';
            }}
          >
            Dashboard
          </LBButton>
        </Padding>
      </TopBar>
      <Background />
    </>
  );
};

export default SendInvitation;
